var $b5a67525f3a2f594$exports = {};
$b5a67525f3a2f594$exports = {
    "breadcrumbs": `Naviga\u{10D}n\xe9 prvky Breadcrumbs`
};


export {$b5a67525f3a2f594$exports as default};
//# sourceMappingURL=sk-SK.module.js.map
